import React from 'react';
import PropTypes from 'prop-types';

import { getStep } from '../../api';

import ProductRadio from '../../ProductRadio';

class Material extends React.PureComponent {
  state = {
    products: window.MTMReact.products,
  };

  componentDidMount() {
    if (!this.props.values.product) {
      this.props.setError('product', 'required');
    }

    if (this.state.products.length === 0) {
      getStep({ ...this.props.values, step: this.props.step }, this.props.setLoading)
        .then(
          (res) => {
            this.setState({
              products: res,
            });
          },
          (error) => {
            console.log(error);
            this.props.setError('generic', error);
          }
        );
    }
  }

  handleChange = (name, value) => {
    if (!value) {
      this.props.setError(name, 'required');
    } else {
      this.props.setError(name);
    }

    const product = this.state.products.find((product) => product.id === value);
    this.props.setValue('meter_price', product.price.string);
  };

  render() {
    return (
      <div id="mtm-material" className="row small-up-2 medium-up-3 mediumlarge-up-4 large-up-3 xlarge-up-4 mtm-grid">
        {this.state.products.map((product) => (
          <ProductRadio
            key={product.id}
            fieldName="product"
            value={product.id}
            name={product.name}
            image={product.image.html}
            price={product.price.string}
            onChange={this.handleChange}
          />
        ))}
      </div>
    );
  }
}

Material.propTypes = {
  step: PropTypes.number.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default Material;





// WEBPACK FOOTER //
// ./src/Step/steps/Material.js